import type { SectionConfig } from '../lib/types';

export const deliverySection: SectionConfig = {
  id: 'setup.del', entity: 'delivery', title: 'Delivery Methods',
  softDelete: true, draggable: true,
  defaultSort: { column: 'sort', direction: 'asc' },
  columns: [
    { key: 'title', title: 'Title', sortable: true },
    { key: 'price', title: 'Price', type: 'number', sortable: true },
    { key: 'enabled', title: 'Enabled', type: 'boolean' },
  ],
  formFields: [
    { key: 'title', title: 'Title', type: 'text', required: true },
    { key: 'description', title: 'Description', type: 'textarea' },
    { key: 'price', title: 'Price (EUR)', type: 'number', required: true },
    { key: 'enabled', title: 'Enabled', type: 'boolean' },
  ],
};

export const deliveryCountrySection: SectionConfig = {
  id: 'setup.cpr', entity: 'deliveryCountry', title: 'Country Pricing',
  softDelete: false, draggable: false,
  columns: [
    { key: 'countryId', title: 'Country', sortable: true },
    { key: 'deliveryId', title: 'Delivery Method', sortable: true },
    { key: 'price', title: 'Price', type: 'number', sortable: true },
  ],
  formFields: [
    { key: 'countryId', title: 'Country', type: 'select', required: true, relation: { entity: 'country', labelField: 'name' } },
    { key: 'deliveryId', title: 'Delivery Method', type: 'select', required: true, relation: { entity: 'delivery', labelField: 'title' } },
    { key: 'price', title: 'Price (EUR)', type: 'number', required: true },
  ],
};

export const orderStatusSection: SectionConfig = {
  id: 'setup.ost', entity: 'orderStatus', title: 'Order Statuses',
  softDelete: false, draggable: true,
  defaultSort: { column: 'sort', direction: 'asc' },
  columns: [
    { key: 'title', title: 'Title', sortable: true },
  ],
  formFields: [
    { key: 'title', title: 'Title', type: 'text', required: true },
  ],
};
